import {Types} from "./deputyActions";
import _ from "lodash";
// import {NotificationManager} from 'react-notifications';

const defaultState = {
  timesheets: {}
};

const deputyReducers = (state = defaultState, action) => {
  switch (action.type) {
    case Types.DEPUTY_CONNECTED: {

      let newState = _.cloneDeep(state);

      newState.deputy.connected = action.connected;
      newState.deputy.needsReconnection = action.needsReconnection;

      return newState;
    }
    case Types.DEPUTY_IMPORTING: {

      let newState = _.cloneDeep(state);

      newState.deputy.importing = action.status ? action.status : undefined;

      return newState;
    }
    case Types.DEPUTY_EMPLOYEES: {

      let newState = _.cloneDeep(state);

      newState.deputy.employees = action.employees;
      newState.deputy.links = action.links || [];

      return newState;
    }
    case Types.DEPUTY_LINK_USER: {

      let newState = _.cloneDeep(state);

      newState.deputy.links = newState.deputy.links ? [...newState.deputy.links] : []

      const index = newState.deputy?.links?.findIndex?.(i => i.agreement == action.user.agreement)

      if (index !== -1){
        newState.deputy.links[index] = action.user
      } else {
        newState.deputy.links.push(action.user)
      }
      return newState;
    }
    default:
      return state;
  }
};

export default deputyReducers;